export enum DialogMode {
	VIEW,
	EDIT,
	ADD
}